import { Claim } from "../types/claim";
import { useNavigate } from "react-router-dom";

interface ClaimsTableRowProps {
  claim: Claim;
}

const ClaimsTableRow = ({ claim }: ClaimsTableRowProps) => {
  const navigate = useNavigate();

  // Helper function for status colors
  const getStatusColorClasses = (statusCode: string) => {
    if (statusCode.startsWith("A4-0")) return "bg-green-100 text-green-800";
    if (statusCode.startsWith("A4-1") || statusCode.startsWith("A3"))
      return "bg-red-100 text-red-800";
    if (statusCode.startsWith("A2")) return "bg-orange-100 text-orange-800";
    return "bg-blue-100 text-blue-800";
  };

  const handleRowClick = () => {
    navigate(`/claims/${claim.id}`);
  };

  return (
    <tr
      className="border-b hover:bg-gray-50 cursor-pointer"
      onClick={handleRowClick}
    >
      <td className="p-2 text-blue-600">{claim.id}</td>
      <td className="p-2">{claim.date}</td>
      <td className="p-2">{claim.patient}</td>
      <td className="p-2">${claim.totalAmount.toLocaleString()}</td>
      <td className="p-2">
        <span
          className={`px-2 py-1 rounded text-sm ${getStatusColorClasses(
            claim.status.code
          )}`}
        >
          {claim.status.desc}
        </span>
      </td>
    </tr>
  );
};

export default ClaimsTableRow;
